import { render } from "./VUEFrameComponenteGraficoEvAcc.vue?vue&type=template&id=bb0da37e"
import script from "./VUEFrameComponenteGraficoEvAcc.vue?vue&type=script&lang=js"
export * from "./VUEFrameComponenteGraficoEvAcc.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__